import find from 'lodash/find'

export default function valueToEnum(enums, predicate, predicateKey = 'key') {
  const result = find(enums, { [predicateKey]: predicate })
  return result || { text: '----' }
}
